$(document).ready(function(){
  $('.toggle-container .toggle-btn').on('click', function(){
      $(this).parent().toggleClass('active');
      $('+ .toggle-content', this).toggleClass('d-block');
  })
})